import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ContractRoutingModule } from './contract-routing.module';
import { ContractSummaryComponent } from './contract-summary/contract-summary.component';
import { ContractService } from './contract.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DisplayIdModule } from '../../../directives';
import { ModalModule } from 'ngx-bootstrap';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient,  HTTP_INTERCEPTORS } from '@angular/common/http';
import { CustomerRoutingModule, CustomerSummaryService } from '../customer';
import { SharedModule } from '../../shared';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CustomInterceptor } from '../../../helper';
import { ContractAddComponent } from './contract-add/contract-add.component';
import { JobSummaryService } from '../job/job-summary';
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DisplayIdModule,
    ModalModule.forRoot(),
    TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient]
    }
  }),
    
    ContractRoutingModule,
    SharedModule,
    ReactiveFormsModule
  ],
  declarations: [ContractSummaryComponent, ContractAddComponent],
  providers: [ContractService, JobSummaryService, CustomerSummaryService,
    { provide: HTTP_INTERCEPTORS, useClass: CustomInterceptor, multi: true }
  ]
})
export class ContractModule { }



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/contract/contract.module.ts